export const DEBUG_SAFE_AREA_KEY = '__debug-safe-area';
export const DEBUG_FULLSCREEN_DISABLED_KEY = '__debug-fullscreen-native-disabled';
